// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3flDc","title":"styles_title__hfY9K"};